import Swiper, {Navigation,EffectFade,Autoplay} from "../../assets/.npm/node_modules/swiper";

export default () => {
  function darkNav() {
    //if ( $('.swiper-slide.swiper-slide-active').hasClass('dark') ) { // `this` rather?
    if ( $(this).find('.swiper-slide-active').hasClass('dark') ) {
      $('#navbar').addClass('darknav')
    } else {
      $('#navbar').removeClass('darknav');
    }
  }
  let swiperBanner = new Swiper(".slider-banner", {
    modules: [Navigation,EffectFade,Autoplay],
    slidesPerView: 1, 
    loop: false,
    effect: 'fade',
    // autoplay: {
    //   delay: 5000,
    // },
    navigation: {
      nextEl: ".slider-next",
      prevEl: ".slider-prev",
    },
    /* events */
    on: {
      slideChange: function(){
        var currentSlide = this.realIndex + 1;
        //console.log("currentSlide is:" + currentSlide);
        document.querySelector('.current-slide').innerHTML = currentSlide;
      },
      beforeInit: function(){
      let numOfSlides = this.wrapperEl.querySelectorAll(".swiper-slide").length;
      document.querySelector('.total-slides').innerHTML = "/ " + numOfSlides;
      }
    },
  });

  let swiperHot = new Swiper(".slider-hot", {
    modules: [Autoplay],
    slidesPerView: 1, 
    reverseDirection: true,
    loop: true,
    autoplay: {
      delay: 2000,
      reverseDirection: true,
      disableOnInteraction: false,
  },
  });
}
  
